import request from './request'

export function contact(params) {
	return request({
		url: 'contact/add',
		method: 'post',
		data: params
	})
}



// WEBPACK FOOTER //
// ./src/api/api.js